import type * as FlexibleTable from '../types/FlexibleTable'

export default function FlexibleTableComponentParser(
  rawComponent: FlexibleTable.Raw,
): FlexibleTable.Parsed {
  const { data, ...props } = rawComponent.flexibleTable
  const { header, body } = data

  return {
    name: 'FlexibleTable',
    props: {
      ...props,
      header: header
        ? header.map((h) => ({ title: h.c, field: h.c }))
        : undefined,
      data: body.map((row) => row.map((item) => item.c)),
    },
  }
}
